import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.unit.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_UNIT_ASYNC: `${uid}.saveUnitAsync`,
    SAVE_UNIT_SUCCESS: `${uid}.saveUnitSuccess`,
    SAVE_UNIT_FAILURE: `${uid}.saveUnitFailure`,
    UPLOAD_AUDIO_ASYNC: `${uid}.uploadAudioAsync`,
    UPLOAD_AUDIO_FAILURE: `${uid}.uploadAudioFailure`,
    UPLOAD_AUDIO_SUCCESS: `${uid}.uploadAudioSuccess`,
    UPLOAD_CHOICE_ASYNC: `${uid}.uploadChoiceAsync`,
    UPLOAD_CHOICE_FAILURE: `${uid}.uploadChoiceFailure`,
    UPLOAD_CHOICE_SUCCESS: `${uid}.uploadChoiceSuccess`,
    REMOVE_CHOICE_FILE: `${uid}.removeChoiceFile`,
    GENERATE_ASYNC: `${uid}.generateAsync`,
    GENERATE_FAILURE: `${uid}.generateFailure`,
    GENERATE_SUCCESS: `${uid}.generateSuccess`,
    SELECT_UNIT_TYPE: `${uid}.selectUnitType`,
    SELECT_TYPE_LIST: `${uid}.selectTypeList`,
    SELECT_ANSWER: `${uid}.selectAnswer`,
    CHANGE_CHARS: `${uid}.changeChars`,
    CHANGE_INPUT: `${uid}.changeInput`,
    SAVE_AND_CREATE_UNIT_ASYNC: `${uid}.saveAndCreateUnitAsync`,
    SAVE_AND_CREATE_UNIT_SUCCESS: `${uid}.saveAndCreateUnitSuccess`,
    SAVE_AND_CREATE_UNIT_FAILURE: `${uid}.saveAndCreateUnitFailure`,
    LOAD_TASK_UNITDATA: `${uid}.loadTaskUnitData`,
    RECREATE:`${uid}.recreate`,
    SEARCH_BY_TYPE_ID: `${uid}.searchByTypeId`

};

export { ActionTypes };
